import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import ProblemSubmitList from '../views/ProblemSubmitList.vue'
import store from '../store/index.js'

Vue.use(Router)

let router = new Router({
    routes: [{
        path: '/',
        name: 'Home',
        component: Home,
        redirect: '/problemSubmitList',
        children: [{
            path: '/problemSubmitList',
            name: 'problemSubmitList',
            component: ProblemSubmitList
        }, {
            path: '/problemSubmit',
            name: 'problemSubmit',
            component: () =>
                import ( /* webpackChunkName: 'ProblemSubmit' */ '../views/ProblemSubmit.vue')
        }, {
            path: '/problemSubmitDetail',
            name: 'problemSubmitDetail',
            component: () =>
                import ( /* webpackChunkName: 'ProblemSubmitDetail' */ '../views/ProblemSubmitDetail.vue')
        }, {
            path: '/personalCenter',
            name: 'personalCenter',
            component: () =>
                import ( /* webpackChunkName: 'PersonalCenter' */ '../views/PersonalCenter.vue')
        }]
    }, {
        path: '/login',
        name: 'login',
        component: () =>
            import ( /* webpackChunkName: 'Login' */ '../views/Login.vue')
    }, {
        path: '/register',
        name: 'register',
        component: () =>
            import ( /* webpackChunkName: 'Register' */ '../views/Register.vue')
    }, {
        path: '/policy',
        name: 'policy',
        component: () =>
            import ( /* webpackChunkName: 'policy' */ '../views/privacyPolicy.vue')
    }, {
        path: '/forgotPwd',
        name: 'ForgotPwd',
        component: () =>
            import ( /* webpackChunkName: 'ForgotPwd' */ '../views/ForgotPwd.vue')
    }]
})

router.beforeEach((to, from, next) => {
    // 如果用户输入的是login页面 直接放行
    if (to.path === '/login' || to.path === '/register' || to.path === '/forgotPwd' || to.path === '/policy') return next();
    // 如果没有token 则直接跳转到登录页
    if (!window.sessionStorage.getItem('token') || !window.sessionStorage.getItem('userCode') || !window.sessionStorage.getItem('userName')) return next('/login')
    store.commit('setUserName', window.sessionStorage.getItem("userName"))
    store.commit('setUserCode', window.sessionStorage.getItem("userCode"))
    store.commit('setUserCompany', window.sessionStorage.getItem("userCompany"))
    store.commit('setToken', window.sessionStorage.getItem("token"))
    store.commit('setUserId', window.sessionStorage.getItem("userId"))
        // 有token放行
    next()
})

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js